function bznCartFieldsUpload() {
  const fields = [...document.querySelectorAll('.bzn-cart-field')];
  fields.forEach(field=>{
    field.addEventListener('change', event=>{
      const target = event.target;
      const formData = new FormData();
      [...document.querySelectorAll('.bzn-cart-field')].forEach(
        field=>formData.append(field.name,  field.type === "checkbox" ? (field.checked ? field.value : '') : field.value));
      //formData.append(target.name, target.type === "checkbox" ? (target.checked ? target.value : '') : target.value);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => bznCartAddDeliveryDateItem(event, data));
    })
    field.dispatchEvent(new Event('change'));
  });
}

function bznCartAddDeliveryDateItem(event, data) {
  const name = event.target?.name;
  if (name === 'attributes[配送希望日]' || name === 'attributes[配送時間帯]') {
    const dateValue = document.querySelector('[name="attributes[配送希望日]"]')?.value;
    const timeValue = document.querySelector('[name="attributes[配送時間帯]"]')?.value;
    if (dateValue?.indexOf("指定無し") >= 0 && timeValue?.indexOf("指定無し") >= 0) {
      // cartに配送日指定が入っていたら削除する
      if (deliveryDateItemExists(data)) {
        deleteDeliveryDateItemFromCart();
      }
    } else {
      if (!deliveryDateItemExists(data)) {
        addDeliveryDateItemToCart();
      }
    }
  }
}

function deleteDeliveryDateItemFromCart() {
  let updates = { 40913186848853: 0 };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates})
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function addDeliveryDateItemToCart() {
  let formData = {
    'items': [{
      'id': 40913186848853,
      'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function deliveryDateItemExists(data) {
  return data.items.reduce((acc, row) => acc ? true : row.id === 40913186848853, false);
}

bznCartFieldsUpload();